import css from "styled-jsx/css";

export const styles = css`
  @media (max-width: 30em) {
    :global(.site_splash--wrapper) {
      height: 19rem;
    }
  }
  @media (min-width: 30em) and (max-width: 60em) {
    :global(.site_splash--wrapper) {
      height: 16rem;
    }
  }
  @media (min-width: 60em) {
    :global(.site_splash--wrapper) {
      height: 22rem;
    }
  }
  :global(.site_splash) {
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    height: 100%;
    width: 100%;
  }

  :global(.site_mariella_splash--img) {
    background-image: url("/assets/site_mariella_splash.png");
  }

  :global(.site_grit_splash--img) {
    background-image: url("/assets/site_grit_splash.png");
  }

  :global(.site_pompeo_splash--img) {
    background-image: url("/assets/site_pompeo_splash.png");
  }

  :global(.site_metric_splash--img) {
    background-image: url("/assets/site_metric_splash.png");
  }
`;
